module.exports = __webpack_public_path__ + "img/gi.b0015a50.svg";